import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import getContent from '../lib/dictionaryFetcher';
import DiscoverCategory from './DiscoverCategory';
import DefaultCategoriesFeatured from './DefaultCategoriesFeatured';
import { sortFavorites, getDedupedDiscoverTools } from '../lib/discover';

/*
 * Collects recommended tools from other categories, smartrec, and recommended marketplaces.
 * Categories are defined in schema/country/default.json and can be configured on a per-country basis.
 * Categories are deduped with getDedupedDiscoverTools and dynamic sections are prioritized there as well.
 */
const Discover = props => {
  const {
    tools,
    category,
    categoryIndexes,
    categories,
    favorites,
    user,
    setApp,
    recommendations
  } = props;

  const getDiscoverTools = () => {
    const sortedFavorites = sortFavorites(favorites, tools),
      dedupedDiscoverTools = getDedupedDiscoverTools(
        {
          category,
          categories,
          sortedFavorites,
          tools,
          user
        },
        recommendations
      );
    return dedupedDiscoverTools;
  };

  const featuredItems = get(user, 'eligibility.otss', []),
    [discoverTools, updateDiscoverTools] = useState(getDiscoverTools()),
    [renderKey, updateRenderKey] = useState(0);

  useEffect(() => {
    updateDiscoverTools(getDiscoverTools());
  }, [favorites]);

  /*  We need to force re-render the discover tab when favoriting, otherwise a bug 
    occurs where the status of the heart icon is reversed for the tool after 
    the one that is favorited also shows as favorited in the UI.
  */
  useEffect(() => {
    updateRenderKey(renderKey + 1);
  }, [discoverTools]);

  const renderSubCategory = subcategory => {
    const { name = '', priority = [], type = '' } = subcategory;
    let title, subcategoryIndex, showViewAll;

    switch (type) {
      case 'featured':
        const featuredItem = priority.find(item =>
          featuredItems.includes(item)
        );
        if (!featuredItem) return null;
        return (
          <DefaultCategoriesFeatured
            featured={featuredItem}
            category={'featured'}
            callback={setApp}
          />
        );
      case 'static':
        subcategoryIndex = get(categoryIndexes, name, '0');
        title = getContent('merchanthub', `categories.${name}`, '');
        showViewAll = true;
        break;
      case 'dynamic':
        title = getContent('merchanthub', `discover.${name}`, '');
        showViewAll = false;
        break;
      default:
        return null;
    }
    if (!discoverTools[name].length) return null;

    return (
      <DiscoverCategory
        title={title}
        items={discoverTools[name]}
        subcategoryIndex={subcategoryIndex}
        showViewAll={showViewAll}
        recommendations={recommendations}
        {...props}
      />
    );
  };

  return (
    <div key={`discover-${renderKey}`}>
      {get(category, 'categories', []).map((subcategory, idx) => (
        <Fragment key={idx}>{renderSubCategory(subcategory)}</Fragment>
      ))}
    </div>
  );
};

Discover.propTypes = {
  user: PropTypes.object,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  tools: PropTypes.object,
  category: PropTypes.object,
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  featured: PropTypes.object,
  recommendations: PropTypes.array,
  favorites: PropTypes.array
};

export default Discover;
